//AEATEAM-724: the content of this file should be copied to Footnotes.ts Mixin when globalelements solution is to move to production
import { BaseDataJson } from '@owc-types/BaseDataJSON';
import { Computed } from '@owc-types/ComponentInitializeDispatcher';
// TODO refactor this using the abstract store
import {
  addFootnotesToStore,
  loadFootnoteComponents,
  mountFootnotes,
} from '@owc-utils/Footnotes/FootnotesHelper';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';

const mixin: ThisTypedComponentOptionsWithRecordProps<Vue, {}, {}, Computed<BaseDataJson>, {}, {}, {}, {}> = {
  created() {
    const unwatch = this.$watch(
      'isComponentDataInitialized',
      function(newValue) {
        if (newValue) {
          this.$nextTick(() => {
            // Triggering footnotes build
            if (this.componentData && this.componentData.footnotes) {
              addFootnotesToStore(this.componentData.footnotes);
            }
            unwatch();
          });
        }
      },
      { deep: true },
    );
    const unwatchId = this.$watch('parentId', function() {
      this.$nextTick(() => {
        if (this.$el instanceof HTMLElement) {
          loadFootnoteComponents();
          mountFootnotes(this);
        }
        unwatchId();
      });
    });
  },
};

export default mixin;
